<template>
  <div class="des—box">
    <div class="des-item" v-for="(item, index) in desList" :key="index">
      <img :src="item.icon" alt="" />
      <div class="right">
         <p class="_title">{{ item.title }}</p>
      <p class="_sub" v-html="item.subTitle"></p>
      <p class="about_us" v-if="item.content">
        {{item.content}}<a @click="aboutUs()" v-if="isShow">联系我们</a>
      </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "conversionDes",
  props: {
    pageName: ""
  },
  data () {
    return {
      APIPort: process.env.APIPort,
      pageType: this.pageName,
      truetarget: 0,
      isShow: true,
      desList: [],
      desList1: [
        {
          icon: require("@comm/images/document-conversion/svg_des_1.svg"),
          title: "支持海量格式快速转换为OFD",
          subTitle:
            "支持的格式：PDF、WPS、Word、Excel、PPT、TXT。",
          content: "更多格式 ： 永中Office、普华Office、XPS、CEB、SEP、S2、S72、S92、PS2、S10、HTML。"
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_5.svg"),
          title: "支持文件批量转换、合并转换",
          subTitle:
            "可选中多个文件进行批量转换。勾选“合并转换为一个文档”选项时，将多个文件合并转换为一个OFD文档。转换完成后，可点击“预览”、“下载”功能进行文档管理。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_4.svg"),
          title: "适用所有操作系统",
          subTitle:
            "其他格式转OFD转换器适用于所有计算机，包括Mac、Windows及Linux。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_3.svg"),
          title: "保障您的文件隐私安全",
          subTitle: "您的隐私安全会受到全面保护，没有人能够访问您的文件。",
        },
      ],
      desList2: [
        {
          icon: require("@comm/images/document-conversion/svg_des_2.svg"),
          title: "直接转换为PDF并阅读",
          subTitle:
            "支持将OFD文档转换为PDF格式，可直接打开并进行阅读，为您提供轻松、高效的转换服务。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_5.svg"),
          title: "支持文件批量转换、合并转换",
          subTitle:
            "可选中多个文件进行批量转换。勾选“合并转换为一个文档”选项时，将多个文件合并转换为一个PDF文档。转换完成后，可点击“预览”、“下载”功能进行文档管理。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_4.svg"),
          title: "适用所有操作系统",
          subTitle:
            "OFD转PDF转换器适用于所有计算机，包括Mac、Windows及Linux。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_3.svg"),
          title: "保障您的文件隐私安全",
          subTitle: "您的隐私安全会受到全面保护，没有人能够访问您的文件。",
        },
      ],
      desList3: [
        {
          icon: require("@comm/images/document-conversion/svg_des_2.svg"),
          title: "支持海量格式快速转换为PDF",
          subTitle:
            "支持的格式：OFD、WPS、Word、Excel、PPT、TXT。",
          content: "更多格式 ： 永中Office、普华Office、XPS、CEB、SEP、S2、S72、S92、PS2、S10、HTML。"
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_5.svg"),
          title: "支持文件批量转换、合并转换",
          subTitle:
            "可选中多个文件进行批量转换。勾选“合并转换为一个文档”选项时，将多个文件合并转换为一个PDF文档。转换完成后，可点击“预览”、“下载”功能进行文档管理。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_4.svg"),
          title: "适用所有操作系统",
          subTitle:
            "其他格式转PDF转换器适用于所有计算机，包括Mac、Windows及Linux。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_3.svg"),
          title: "保障您的文件隐私安全",
          subTitle: "您的隐私安全会受到全面保护，没有人能够访问您的文件。",
        },
      ],
      desList4: [
        {
          icon: require("@comm/images/document-conversion/svg_des_8.svg"),
          title: "将OFD/PDF文档转换为图片 ",
          subTitle:
            "单次转换可将OFD/PDF文档的部分页面（前20页）转换为图片。支持转换的图片格式：PNG、JPG。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_6.svg"),
          title: "支持输出长图",
          subTitle:
            "可将选中的文档页面合并输出一张长图，单张长图最多支持选中10张文档页面。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_4.svg"),
          title: "适用所有操作系统",
          subTitle:
            "OFD/PDF转图片转换器适用于所有计算机，包括Mac、Windows及Linux。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_3.svg"),
          title: "保障您的文件隐私安全",
          subTitle: "您的隐私安全会受到全面保护，没有人能够访问您的文件。",
        },
      ],
      desList5: [
        {
          icon: require("@comm/images/document-conversion/svg_des_8.svg"),
          title: "将图片合并转换为OFD/PDF",
          subTitle:
            "将多张图片合并转换为单个OFD或PDF文件。转换完成后，点击“预览”、“下载”功能进行文档管理。",
          content: "支持转换的图片格式：PNG、JPG、BMP、TIFF。"
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_7.svg"),
          title: "支持图片拖拽顺序",
          subTitle:
            "选择多张图片后，通过拖拽图片对其进行排序，生成最终文档页面顺序。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_4.svg"),
          title: "适用所有操作系统",
          subTitle:
            "图片转OFD/PDF转换器适用于所有计算机，包括Mac、Windows及Linux。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_3.svg"),
          title: "保障您的文件隐私安全",
          subTitle: "您的隐私安全会受到全面保护，没有人能够访问您的文件。",
        },
      ],
      desList6: [
        {
          icon: require("@comm/images/document-conversion/svg_des_9.png"),
          title: "支持将OFD文档转换为CEB格式",
          subTitle:
            "支持将OFD文档转换为CEB格式",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_7.svg"),
          title: "支持文件批量转换、合并转换",
          subTitle:
            "可选中多个文件进行批量转换。勾选 ”合并转换为一个文档“ 选项时，将多个文件合并转换为一个CEB文档。转换完成后，可点击“下载”和“打包下载”功能进行文档管理。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_4.svg"),
          title: "适用所有操作系统",
          subTitle:
            "OFD转CEB转换器适用于所有计算机，包括Mac、Windows及Linux。",
        },
        {
          icon: require("@comm/images/document-conversion/svg_des_3.svg"),
          title: "保障您的文件隐私安全",
          subTitle: "您的隐私安全会受到全面保护，没有人能够访问您的文件。",
        },
      ],
    };
  },
  watch: {
    pageName (val) {
      this.pageType = val
      if (val == 'toofd') {
        this.desList = this.desList1
      } else if (val == 'ofdtopdf') {
        this.desList = this.desList2
      } else if (val == 'topdf') {
        this.desList = this.desList3
      } else if (val == 'toceb') {
        this.desList = this.desList6
      }
    }
  },
  created () {
    if (this.$route.path == '/imgConversion/'&&this.$route.query.type=='toofd') {
      this.isShow=false
      this.desList = this.desList5
    } else if (this.pageType == 'toofd') {
      this.isShow=true
      this.desList = this.desList1
    } else if (this.pageType == 'ofdtopdf') {
      this.isShow=true
      this.desList = this.desList2
    } else if (this.pageType == 'topdf') {
      this.isShow=true
      this.desList = this.desList3
    } else if (this.pageType == 'toimg') {
      this.isShow=true
      this.desList = this.desList4
    }
  },
  mounted () { },
  methods: {
    aboutUs () {
      let that = this
      this.$emit("callUs", true);
      setTimeout(function () {
        that.$emit("callUs", false);
      }, 10000)
    },
  },
};
</script>

<style scoped>
.des—box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  padding: 88px 32px 0;
}
.des—box .des-item {
  width: 508px;
  margin-bottom: 76px;
  display: flex;
  align-items: flex-start;
}
.des—box .des-item img {
  width: 64px;
  margin-right: 32px;
}
.des—box .des-item .right {
  flex: 1;
}
.des—box .des-item ._title {
  font-size: 20px;
  color: #242f44;
  line-height: 32px;
  margin-bottom: 8px;
}
.des—box .des-item ._sub {
  font-size: 14px;
  color: #36425a;
  line-height: 32px;
  margin: 0;
}
.des—box .des-item .about_us {
  padding-top: 8px;
  margin-bottom: 0;
  font-size: 14px;
  color: #36425a;
  line-height: 32px;
}
.des—box .des-item .about_us a {
  color: #14a8f0;
  cursor: pointer;
  text-decoration: underline;
}
.des—box .des-item .about_us a:focus,
.des—box .des-item .about_us a:active {
  color: #1299d9;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/conversionDes/index.vue